import React from 'react';

import { Control, UseFormSetValue } from 'react-hook-form';
import { Divider, Tab, Tabs } from '@mui/material';
import { StudentDetailProps } from '../types/studentDetailType';
import { SnackbarSeverityType } from '../../../enums';
import { StudentTabOptions } from '../config/constant';
import Icons from '../../../components/icons';
import { studentTabTypes } from '../types';
import pallet from '../../../layouts/pallet';
import StudentTabContent from './StudentTabContent';

const StudentDetailForm = ({
  control,
  setValue,
  showToast,
  activeTab,
  setActiveTab
}: {
  control: Control<StudentDetailProps, any, StudentDetailProps>;
  setValue: UseFormSetValue<StudentDetailProps>;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
  activeTab: studentTabTypes;
  setActiveTab: React.Dispatch<React.SetStateAction<studentTabTypes>>;
}) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabId = StudentTabOptions[newValue]?.id;
    if (tabId) {
      setActiveTab(tabId);
    }
  };

  const selectedTab = StudentTabOptions.findIndex(
    (tab) => tab.id === activeTab
  );

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label='icon position tabs example'
      >
        {StudentTabOptions.map((tab) => {
          const IconComponent =
            activeTab === tab.id ? tab.selectedIcon : tab.unselectedIcon;
          const Icon = IconComponent || Icons.UserFilled;
          return (
            <Tab
              key={tab.id}
              icon={
                <Icon
                  style={{
                    height: '18px',
                    width: '18px',
                    marginRight: 8
                  }}
                />
              }
              sx={{
                fontWeight: '500',
                color: pallet.formLabelText,
                textTransform: 'capitalize',
                padding: '8px 20px',
                fontSize: '15px'
              }}
              iconPosition='start'
              label={tab.label}
            />
          );
        })}
      </Tabs>
      <Divider sx={{ mb: 3, maxWidth: '645px' }} />

      <StudentTabContent
        activeTab={activeTab}
        control={control}
        setValue={setValue}
        showToast={showToast}
      />
    </>
  );
};

export default StudentDetailForm;
